import React from 'react'

const Achivement = () => {
  return (
    
    <div className='min-h-[80vh]'>
      <h1 className='text-4xl pt-8 text-white text-center hover:text-indigo-500 text-3xl font-semibold'>My Achivements</h1>
      <div className='grid lg:grid-cols-3 grid-cols-1 container mx-auto py-14 gap-10'>

  <div className='animate__animated animate__bounceInDown animate__delay-1s'>
          <img src="/achivement/HazratAliachieve.jpg" alt="" />
        </div>

        <div className='animate__animated animate__bounceInUp animate__delay-1s'>
          <img src="/achivement/Codechef.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/HackerRank.jpg" alt="" />
        </div>


      <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/Leetcode.jpg" alt="" />
        </div>

        
<div className='animate__animated animate__fadeInRight animate__delay-2s'>
          <img src="/achivement/icpchazrat.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
          <img src="/achivement/Hazratphitron.jpeg" alt="" />
        </div>


      <div className='animate__animated animate__slideInLeft animate__delay-1s'>
          <img src="/achivement/github.jpg" alt="" />
        </div>

        <div className='animate__animated animate__bounceInDown animate__delay-2s'>
          <img src="/achivement/batch5.jpg" alt="" />
        </div>


      <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/phitroncampau.jpg" alt="" />
        </div>

       

      <div className='animate__animated animate__fadeInRight animate__delay-1s'>
          <img src="/achivement/achievement.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
          <img src="/achivement/blackbelt.png" alt="" />
        </div>

        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/pherolevel.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInRight animate__delay-.5s'>
          <img src="/achivement/ambassdor.jpg" alt="" />
        </div>

  <div className='animate__animated animate__fadeInRight animate__delay-1s'>
          <img src="/achivement/hazraticpc.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
          <img src="/achivement/hazrataliicpc.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/ICPChazrat.png" alt="" />
        </div>


      <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/icpcteam.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInRight animate__delay-1s'>
          <img src="/achivement/contest.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/iusachieve.png" alt="" />
        </div>
  

        <div className='animate__animated animate__fadeInRight animate__delay-2s'>
          <img src="/achivement/certificate.jpg" alt="" />
        </div>
        <div className='animate__animated animate__fadeInUp animate__delay-.5s'>
          <img src="/achivement/phitron.jpg" alt="" />
        </div>

      
        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/psb.png" alt="" />
        </div>

         <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/sql_basic.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
          <img src="/achivement/jobplacement.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/python_basic_certificate.jpg" alt="" />
        </div>


      <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/Programming Foundation.jpg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInRight animate__delay-1s'>
          <img src="/achivement/psi.png" alt="" />
        </div>

        <div className='animate__animated animate__fadeInLeft animate__delay-.5s'>
          <img src="/achivement/icpccertificate.jpeg" alt="" />
        </div>
        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/python.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInRight animate__delay-.5s'>
          <img src="/achivement/java.jpeg" alt="" />
        </div>
        <div className='animate__animated animate__fadeInRight animate__delay-1s'>
          <img src="/achivement/webbootcamp.jpeg" alt="" />
        </div>

        <div className='animate__animated animate__fadeInUp animate__delay-1s'>
          <img src="/achivement/javascript_basic certificate.pdf.jpg" alt="" />
        </div>
  

        <div className='animate__animated animate__fadeInRight animate__delay-2s'>
          <img src="/achivement/webdevelopment.jpeg" alt="" />
        </div>
        <div className='animate__animated animate__fadeInUp animate__delay-.5s'>
          <img src="/achivement/math olympiad.jpg" alt="" />
        </div>

         <div className='animate__animated animate__fadeInRight animate__delay-2s'>
          <img src="/achivement/hazrat_phitron.jpg" alt="" />
        </div>
        <div className='animate__animated animate__fadeInUp animate__delay-.5s'>
          <img src="/achivement/hazrat_ali.jpg" alt="" />
        </div>

      
        <div className='animate__animated animate__fadeInDown animate__delay-1s'>
          <img src="/achivement/managingdirector.jpeg" alt="" />
        </div>

        
        
    
        
      </div>
    </div>
  )
}

export default Achivement

// Achievement